module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plates",
    attrs: {
      "id": "plates30"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "plate30",
      "src": "images/plate30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Some of the boys: From left, Sgt Jimmy Wellsman, PO George Ferries, FO Tony Tuckson, FO John Lenagen, FO D F Evans, RWF, PO D Downes, PO Tony Brook, PO F S Young, Sgt David Wheeler, FO Ernie Weatherhead (Adj), FL Robin Norwood, PO A McIntyre.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf2d7242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_TallyHo_plates30.vue
// module id = 153
// module chunks = 0